/**
 * #577 (d-20260924-03) — the three sounds, all Creative Commons 0 from Freesound. Provenance for
 * each file is in `app/public/audio/ATTRIBUTION.md`. A missing entry here would make the provider
 * stay silent and send no request, which is its documented behaviour for an absent asset.
 *
 * Its own module because two providers need it: the app's (`App.jsx`) and the kiosk's
 * (`routes/DisplayRoute.jsx`), whose own provider shadows the app's for the whole board. `App.jsx`
 * imports `DisplayRoute`, so the kiosk importing this from `App.jsx` would be a cycle.
 */
export const AUDIO_ASSETS = Object.freeze({
  completionChime: '/audio/completion-chime.mp3',
  paydayFanfare: '/audio/payday-fanfare.mp3',
  villageAmbience: '/audio/village-ambience.mp3',
});
